// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const Portal = require('client-v2/common/components/portal')
const { CheckRollout } = require('client-v2/common/containers/rollouts')
const withCommonRoot = require('client-v2/common/components/root')
const AppFooter = require('client-v2/common/containers/app-footer/component-smart')
const AppHeader = require('client-v2/common/containers/app-header/component-smart')
const AppNav = require('client-v2/common/containers/app-nav/component-smart')
const ArticleProfileModalV1 = require('client-v2/common/containers/article-profile/components/modal-smart')
const ArticleProfileModalV2 = require('client-v2/common/containers/article-profile/components-v2/modal-smart')
const ArticleProfileV1DetailCard = require('client-v2/common/containers/article-profile/components/detail-card-smart')
const ArticleProfileV1Related = require('client-v2/common/containers/article-profile/components/related-smart')
const ArticleProfileV2DetailCard = require('client-v2/common/containers/article-profile/components-v2/detail-card-smart')
const ArticleProfileV2Related = require('client-v2/common/containers/article-profile/components-v2/related-smart')
const AuthModal = require('client-v2/common/containers/auth-modal/component-smart')
const OpenInAppButton = require('client-v2/common/containers/open-in-app-button/component-smart')

const bem = BemEntity('ArticleProfileLayout')

function ArticleProfileLayout() {
  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('page')
      },
        tag(AppHeader, {
          className: bem.element('header')
        }),
        tag('div', {
          className: bem.element('body')
        },
          tag(CheckRollout, {
            rolloutKey: 'article_profile_v2',
            renderExcluded: () => (
              tag('div', {
                className: bem.element('detail', 'v1')
              },
                tag(ArticleProfileV1DetailCard),
                tag(ArticleProfileV1Related)
              )
            ),
            renderIncluded: () => (
              tag('div', {
                className: bem.element('detail', 'v2')
              },
                tag(ArticleProfileV2DetailCard),
                tag(ArticleProfileV2Related)
              )
            )
          })
        ),
        tag(AppFooter),
        tag(AppNav, {
          className: 'AppNav--mobile'
        })
      ),
      Portal.toModalRoot(
        tag(CheckRollout, {
          rolloutKey: 'article_profile_v2',
          renderExcluded: () => (
            tag(ArticleProfileModalV1)
          ),
          renderIncluded: () => (
            tag(ArticleProfileModalV2)
          )
        }),
        tag(OpenInAppButton),
        tag(AuthModal)
      )
    )
  )
}

module.exports = withCommonRoot(ArticleProfileLayout)
